import { useEffect, useMemo } from 'react';
import { useUpgradeReload } from './utils/upgrade-reload';
import { PageLayout, useGet } from 'shared';
import * as Sentry from '@sentry/react';
import { OrgContext } from './utils/useOrg/useOrg';
import { useAlerts } from "./utils/alert-channel";
import { Account } from './account';

interface Me {
  email: string;
  id: string;
}

export const Layout = () => {
	useUpgradeReload();
  const { alerts } = useAlerts();

	const [me] = useGet<Me>("/api/me")
  useEffect(() => {
		if (me) {
			Sentry.setUser({ email: me.email });
		}
	}, [me]);

	const pages = useMemo(() => {
		return [
      { name: `Alerts (${alerts.length})`, path: '/alerts', danger: alerts.some(({ level }) => level === 'error') },
			{ name: 'Props', path: '/props' },
			{ name: 'Export', path: '/export' },
			{ name: 'Settings', path: '/settings' },
		]
	}, [alerts]);

	return <OrgContext>
    <PageLayout pages={pages} extra={<Account email={me?.email} />} />
	</OrgContext>;
};
